import { observer } from 'mobx-react';
import { useStore, useTitle } from '../../core/utils/hook';

import './styles.scss';
import { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import UnCompletedCourseTab from './UnCompletedCourseTab';
import CompletedCourseTab from './CompletedCourseTab';
import { COURSE_BY_STUDENT_STATUS, SYSTEM_PATH } from '../../core/configs/constants';
import { useNavigate } from 'react-router-dom';

const TRAINING_COURSE_TYPE = {
    UNCOMPLETED_TRAINING_COURSE: {
        VALUE: 1,
        LABEL: '未修了'
    },
    COMPLETED_TRAINING_COURSE: {
        VALUE: 2,
        LABEL: '修了'
    }
}

const TrainingCourseScreen = observer(({ pageTitle }) => {
    // other
    useTitle(pageTitle);
    const navigate = useNavigate();
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;

        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };

        // Follow initial height header
        updateHeight();

        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);

        // Follow resize window
        window.addEventListener('resize', updateHeight);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    // store
    const { courseStore: { lstTrainingCourse, lstTrainingCourseGroupedByTicketPlans, getTrainingCourseList } } = useStore();

    // state
    const [typeTrainingCourse, setTypeTrainingCourse] = useState(TRAINING_COURSE_TYPE.UNCOMPLETED_TRAINING_COURSE.VALUE);
    const trainingCourseByType = useMemo(() => {
        let lstTrainingCourseNotAttend = [];
        let lstTrainingCourssAttending = [];
        if (lstTrainingCourse?.length > 0) {
            lstTrainingCourseNotAttend = lstTrainingCourse.filter(trainingCourse => !trainingCourse?.statusUserCourse &
                trainingCourse.statusUserCourse !== 0);
            lstTrainingCourssAttending = lstTrainingCourse.filter(trainingCourse =>
                COURSE_BY_STUDENT_STATUS.USER_COURSE_ATTENDING.value.includes(trainingCourse?.statusUserCourse));
        }
        return {
            lstTrainingCourseNotAttend,
            lstTrainingCourssAttending
        }

    }, [lstTrainingCourse]);

    // lifecycle
    useEffect(() => {
        fetchData();
    }, []);

    // function
    const fetchData = () => {
        getTrainingCourseList({ groupByTicketPlan: true });
    }

    return (
        <div id="main" className="">
            <div className="bres-cus" 
                style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
                <div className="container">
                    <ul>
                        <li>
                            <a href="/">
                                <img src="/images/icon-home.png" alt="" />
                            </a>
                        </li>
                        <li className="dash">\</li>
                        <li>{pageTitle}</li>
                    </ul>
                </div>
            </div>
            <div className="training-list-screen">
                <div className="container">
                    <h1 className="title-primary">{pageTitle}</h1>

                    {
                        lstTrainingCourse?.length > 0 ? (
                            <>
                                <div className='filter-sidebar d-flex mg-t-25'>
                                    <FilterItem
                                        title={TRAINING_COURSE_TYPE.UNCOMPLETED_TRAINING_COURSE.LABEL}
                                        onClickFilterItem={() => {
                                            if (typeTrainingCourse === TRAINING_COURSE_TYPE.COMPLETED_TRAINING_COURSE.VALUE) {
                                                setTypeTrainingCourse(TRAINING_COURSE_TYPE.UNCOMPLETED_TRAINING_COURSE.VALUE);
                                            }
                                        }}
                                        isActive={typeTrainingCourse === TRAINING_COURSE_TYPE.UNCOMPLETED_TRAINING_COURSE.VALUE}
                                    />
                                    <FilterItem
                                        title={TRAINING_COURSE_TYPE.COMPLETED_TRAINING_COURSE.LABEL}
                                        onClickFilterItem={() => {
                                            if (typeTrainingCourse === TRAINING_COURSE_TYPE.UNCOMPLETED_TRAINING_COURSE.VALUE) {
                                                setTypeTrainingCourse(TRAINING_COURSE_TYPE.COMPLETED_TRAINING_COURSE.VALUE);
                                            }
                                        }}
                                        isActive={typeTrainingCourse === TRAINING_COURSE_TYPE.COMPLETED_TRAINING_COURSE.VALUE}
                                    />
                                </div>

                                <div className='content'>
                                    {
                                        typeTrainingCourse === TRAINING_COURSE_TYPE.UNCOMPLETED_TRAINING_COURSE.VALUE ? (
                                            <UnCompletedCourseTab
                                                onFetchData={fetchData}
                                                lstTrainingCourseNotAttend={trainingCourseByType.lstTrainingCourseNotAttend}
                                                lstTrainingCourssAttending={trainingCourseByType.lstTrainingCourssAttending}
                                                lstTrainingCourseGroupedByTicketPlans={lstTrainingCourseGroupedByTicketPlans} />
                                        ) : (
                                            <CompletedCourseTab
                                                fetchData={fetchData}
                                                lstTrainingCourseGroupedByTicketPlans={lstTrainingCourseGroupedByTicketPlans} />
                                        )
                                    }
                                </div>
                            </>
                        ) : (
                            <div className='d-flex align-items-center justify-content-center flex-column flex-gap-15 min-height-400'>
                                <img src='/images/icon-warning.svg' alt='' />
                                <span>現在、指定された研修講座はありません。</span>
                                <button
                                    onClick={() => navigate(SYSTEM_PATH.THEMES)}
                                    type='button'
                                    className='btn btn-default-3 min-width-120'>講座一覧画面に戻る</button>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
});

const FilterItem = ({ title, onClickFilterItem, isActive }) => {
    return (
        <div
            className={classNames('filter-item', isActive && 'filter-item-active')}
            onClick={() => onClickFilterItem()}
        >
            {title}
        </div>
    )
};

export default TrainingCourseScreen;